import { createApp } from 'vue';
import VueGtag from 'vue-gtag';

import App from './App.vue';
import store from './store';
import setGlobals from './globals';
import i18n from './i18n';
import FontAwesomeIcon from './icons';
import router from './router';

import './validate';
import 'bootstrap';

//Import Vue Mask and apply workaround for Vue 3 compatibility.
import { VueMaskDirective } from 'v-mask';
const vMaskV2 = VueMaskDirective;
const vMaskV3 = {
    beforeMount: vMaskV2.bind,
    updated: vMaskV2.componentUpdated,
    unmounted: vMaskV2.unbind
};

//INITIIALIZE LOCALE
//First, check URL for language breadcrumb in the query string. This supercedes whatever is stored in localstorage.
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('l')) {
    store.commit('setLocale', urlParams.get('l')); //l stands for locale / language.
//Otherwise, commit initializeLocale which checks localstorage for locale.
} else {
    store.commit('initializeLocale');
}
i18n.global.locale = store.state.locale;

//Instantiate the vue app and capture the instance for more configuration.
const app = createApp(App)
    .use(store)
    .use(i18n)
    .use(router)
    .use(VueGtag, {
        config: {
            id: process.env.VUE_APP_GA_MEASUREMENT_ID
        }
    }, router)
    .component('font-awesome-icon', FontAwesomeIcon)
    .directive('mask', vMaskV3);


//Set globally available config & helper functions.
setGlobals(app);

//Finally, mount the app.
app.mount('#app');